import React from "react";
import { Offline } from "react-detect-offline";

import styles from "./OnlineStatus.module.scss";

const OnlineStatus: React.FC = () => {
  return (
    <Offline>
      <div className={styles.container}>No Internet Connection</div>
    </Offline>
  );
};

export default OnlineStatus;
